import type { GetInstructorsRequest } from '@features/instructors/api/get-instructors/getInstructors.types';
import type { SortBy } from '@features/instructors/types/sort.types';
import type { SortDirection } from '@shared/types/sort.types';

export function buildSortParam(
  sortBy: SortBy,
  sortDirection: SortDirection
): NonNullable<GetInstructorsRequest['sort']> {
  const prefix = sortDirection === 'desc' ? '-' : '';
  return `${prefix}${sortBy}` as NonNullable<GetInstructorsRequest['sort']>;
}
